import { CommonModule } from '@angular/common'
import { Component, Input } from '@angular/core'

import { References } from '@cyborg-monorepo/hunter/common'
import { BadgeComponent, LinkComponent, TypographyComponent } from '@hyperkit'

@Component({
  standalone: true,
  selector: 'shared-references',
  imports: [CommonModule, BadgeComponent, LinkComponent, TypographyComponent],
  templateUrl: './references.component.html',
  styleUrls: ['./references.component.scss'],
})
export class ReferencesComponent {
  @Input() references: References | undefined
}
